import { render } from "./OutdatedRegister.vue?vue&type=template&id=5eaf66d8"
import script from "./OutdatedRegister.vue?vue&type=script&lang=js"
export * from "./OutdatedRegister.vue?vue&type=script&lang=js"

import "./OutdatedRegister.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__